// client/src/pages/datasets/DataSetsList.js
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";
import { useOrg } from "../orgs/org-context";
import ImportSpreadsheetModal from './ImportSpreadsheetModal';


export default function DataSetsList() {
  const navigate = useNavigate();
  const { activeOrgId, activeOrg } = useOrg();
  const [tableKey, setTableKey] = useState(0);
  const [importOpen, setImportOpen] = useState(false);
  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";

  // Remount table when org changes (forces fresh fetch)
  useEffect(() => setTableKey((k) => k + 1), [orgId]);

  const columns = useMemo(
    () => [
      { label: "", type: "count", value: "__count", width: "48px", align: "center" },
      { label: "Name", value: "name", search: "name", width: "240px" },
      {
        label: "Description",
        value: "description",
        search: "description",
        type: "render",
        width: "360px",
        render: (row) => (
          <div
            style={{
              maxWidth: 360,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={row.description || ""}
          >
            {row.description || ""}
          </div>
        ),
      },
      {
        label: "Updated",
        value: "updatedAt",
        width: "180px",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""),
      },
    ],
    []
  );

  const buttons = [
    { label: "Edit Project",  class: "btn-edit",   action: "/datasets/edit/{_id}" },
    { label: "Actions List", color: "orange", action: "/datasets/actions/{_id}" },
    { label: "Copy", color: "blue", requestPath: "/datasets/copy/{_id}", successMessage: "Project copied." },
    { label: "Delete",         class: "btn-danger",    action: "delete" },
  ];

  return (
    <div className="datatable-page">
      {/* Title bar -- same pattern as Landing Pages */}
      <div
        className="datatable-header-row"
        style={{ justifyContent: "space-between" }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20}}>
          Project List
        </div>
      </div>

      <SmartDataTable
        key={`datasets-${orgId}-${tableKey}`}
        config={{
          columns,
          queryName: "/datasets/list",
          pageSize: 20,
          buttons,
          deletePathTemplate: "/datasets/delete/{_id}",
          deleteMethod: "POST",
          // Place both buttons next to "Add New" slot in the SmartDataTable header row
          headerActions: (
            <>
              <button
                className="btn-green add-new-button"
                onClick={() => navigate("/datasets/add")}
              >
                Add New Project
              </button>
              <button
                className="btn-blue add-new-button"
                onClick={() =>
                  setImportOpen(true)
                }
              >
                Create Project From Spreadsheet
              </button>
            </>
          ),
        }}
      />
      <ImportSpreadsheetModal
        open={importOpen}
        onClose={(refresh) => {

          setImportOpen(false);

          if (refresh) {

            setTableKey(k => k + 1);

          }

        }}
      />
    </div>
  );
}
